import type { Dispatch, SetStateAction } from "react";
import { createContext, useContext, useEffect, useState } from "react";
import { router, useGlobalSearchParams } from "expo-router";

import { PaymentModal } from "~/component/feature/paywall/payment-modal";

interface PaymentContextProps {
  isOpened: boolean;
  setIsOpened: Dispatch<SetStateAction<boolean>>;
}

export const PaymentContext = createContext<PaymentContextProps | undefined>(
  undefined,
);

export function usePaymentContext() {
  const context = useContext(PaymentContext);

  if (!context) {
    throw new Error("PaymentProvider wasn't found");
  }

  return context;
}

export function PaymentProvider({ children }: { children: React.ReactNode }) {
  const { usepayment } = useGlobalSearchParams<{ usepayment?: string }>();
  const [isOpened, setIsOpened] = useState(false);

  useEffect(() => {
    if (usepayment) {
      setIsOpened(true);
      router.setParams({ usepayment: undefined });
    }
  }, [usepayment, setIsOpened]);

  return (
    <PaymentContext.Provider value={{ isOpened, setIsOpened }}>
      {isOpened && <PaymentModal onClose={() => setIsOpened(false)} />}
      {children}
    </PaymentContext.Provider>
  );
}
